import { history } from '..'

export default (store) => (next) => (action) => {
  const { type, payload } = action

  if (type !== 'GET_AUTH_TOKEN') {
    return next(action)
  }

  if (payload.mfa_enabled) {
    const lastRequestTime = localStorage.getItem('lastRequestTime')
    !lastRequestTime &&
      localStorage.setItem('lastRequestTime', String(Date.now()))

    history.push('/auth/two-factor-auth', payload.credentials)
  }
}
